// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"addForm_AddNewGoalPop__wA2qj","modalBody":"addForm_modalBody__khttM","formControl":"addForm_formControl__q-3si","add":"addForm_add__Clj9V"};